import { environment } from "../../../environments/environment";
import { ApiEnvNames, SearchConfig } from "./api.model";
import { FETCH_METHODS } from "./common.model";
import { DataTableSchema, DefaultTableSchema } from "./dynamic-data-table.model";
import { AreaDropdown, AttendanceDropdown, DealerNumber, defaultSearchContainerButtons, EventDropdown, FieldNames, JobRoleDropdown, SpinIdNumber } from "./form-fields.model";
import { ButtonFieldConfig, DynamicFormArray, FormFieldConfig, Props } from "./form.model";

export const getElevateBillingBaseUrl = () => {
  return environment[ApiEnvNames['ElevateBilling']];
};
export const ElevateBillingReportTableSchema: DataTableSchema = {
  ...structuredClone(DefaultTableSchema),
  columnSchema: [
      { label: 'Spin ID', fieldKey: 'spinId', sticky: true },
      { label: 'Dealer', fieldKey: 'dealerCode', sticky: true },
      { label: 'Event', fieldKey: 'event'},
      { label: 'Name', fieldKey: 'name' },
      { label: 'Status', fieldKey: 'status' },
      { label: 'Area', fieldKey: 'area' },
      { label: 'Job Role', fieldKey: 'jobRole' },
      { label: 'Amount($)', fieldKey: 'amount' }
  ],
  exportConfig: {
      fileName: 'Elevate_Billing',
      exportMessage: "Elevate Billing Data",
      isCamelCase:['event','name','jobRole','area'],
      schema:{
        spinId:"SPIN ID",
        dealerCode:"DEALER",
        event:"EVENT",
        name:"NAME",
        status:"STATUS",
        area:"AREA",
        jobRole:"JOB ROLE",
        amount:"AMOUNT ($)"
      }
  }
}

const FilterFields: FormFieldConfig[] = structuredClone([SpinIdNumber, {...structuredClone(EventDropdown),isLoading:true}, DealerNumber, {...structuredClone(JobRoleDropdown),isLoading:true}, {...AreaDropdown,mutiple:true}, AttendanceDropdown])
const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);

export const ElevateBillingReportSearchConfig :SearchConfig = {
  path: 'billingReportSearch',
  method: FETCH_METHODS['Post'],
  body:{
      [FieldNames['SpinId']]: null,
      [FieldNames['JobRole']]:null,
      [FieldNames['AreaDistrict']]: null,
      [FieldNames['DealerNumber']]:null,
      [FieldNames['Attendance']]:null,
      [FieldNames['Event']]: null
    }
}

export const ElevateBillingReportProps: Props = {
  isSearchVisible: false,
  isTabStretch: true
}

export const ElevateBillingReportFormArray: DynamicFormArray = {
  FieldsArray: FilterFields,
  ButtonsArray: FormButtonArray
}